import { useContext } from 'react'

import { CatalogContext, HeaderContext } from '@/providers/HeaderContextProvider'

export function useHeaderContext() {
  const {
    isMegaMenuOpen,
    setIsMegaMenuOpen,
    isSideMenuOpen,
    setIsSideMenuOpen,
    selectedMenuItem,
    setSelectedMenuItem,
    megaMenuRef,
    menuItemsBarRef,
    setForceClose,
    forceClose,
    isSearchOpen,
    setIsSearchOpen,
    headerAppBarRef,
  } = useContext(HeaderContext)

  const catalog = useContext(CatalogContext)

  const focusMegaMenuContent = () => {
    if (megaMenuRef.current) {
      const element = megaMenuRef.current.querySelector('a')
      if (element) {
        element.focus()
      }
    }
  }

  const focusSelectedMenuItem = () => {
    if (menuItemsBarRef.current) {
      const element = menuItemsBarRef.current.querySelector<HTMLAnchorElement>(`a[data-hovered="true"]`)
      if (element) {
        element.focus()
      }
    }
  }

  const toggleIsMegaMenuOpen = (state: boolean, menuItem?: string | null, isCloseAction?: boolean) => () => {
    setIsMegaMenuOpen(state)

    if (typeof isCloseAction == 'boolean') {
      setForceClose(isCloseAction)
    }

    if (menuItem) {
      setSelectedMenuItem(menuItem)
    }
  }

  const toggleSideMenuOpen = (open: boolean) => () => {
    setIsSideMenuOpen(open)
  }

  return {
    isMegaMenuOpen,
    toggleIsMegaMenuOpen,
    isSideMenuOpen,
    toggleSideMenuOpen,
    selectedMenuItem,
    focusMegaMenuContent,
    focusSelectedMenuItem,
    megaMenuRef,
    menuItemsBarRef,
    forceClose,
    isSearchOpen,
    setIsSearchOpen,
    headerAppBarRef,
    catalog,
  }
}
